export const TYPES = {
  SELECT_ALL_INCOME_SUCCESS: "cashup/SELECT_ALL_INCOME_SUCCESS",
  SELECT_ALL_BRANCH_SUCCESS: "cashup/SELECT_ALL_BRANCH_SUCCESS",
  SELECT_USER_INFO_SUCCESS: "cashup/SELECT_USER_INFO_SUCCESS",
  SELECT_DETAIL_CASHUP: "cashUp/SELECT_DETAIL_CASHUP",
  SELECT_ALL_CASHUP: "cashUp/SELECT_ALL_CASHUP",
};
